export default __webpack_public_path__ + "static/media/pop.9cd923eb.mp3";